"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WithCheckPermissionsListWrapper = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const mui_page_layout_1 = require("@dzambalaorg/mui-page-layout");
const styled_1 = require("@framework/styled");
const WithCheckPermissionsListWrapper = (props) => {
    const { count, children, isLoading, ...restProps } = props;
    return ((0, jsx_runtime_1.jsx)(mui_page_layout_1.ProgressOverlay, { isLoading: isLoading, ...restProps, children: (0, jsx_runtime_1.jsx)(styled_1.StyledListWrapper, { count: count, isLoading: isLoading, children: children }) }));
};
exports.WithCheckPermissionsListWrapper = WithCheckPermissionsListWrapper;
//# sourceMappingURL=index.js.map